import { useEffect, useState } from "react";

const links = [
  { label: "Space", href: "#gallery" },
  { label: "Equipment", href: "#equipment" },
  { label: "Contact", href: "#contact" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (e, href) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-[#FAFAFA]/80 backdrop-blur-md border-b border-neutral-200" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto max-w-[1600px] px-6 sm:px-10 h-16 flex items-center justify-end">
        <div className="flex items-center gap-7 sm:gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => go(e, l.href)}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="nav-link font-body text-sm tracking-wide text-neutral-900"
            >
              {l.label}
            </a>
          ))}
        </div>
      </nav>
    </header>
  );
};
